(function(){
  'use strict';

  function FilterTableActionsCtrl() {

  }

  FilterTableActionsCtrl.prototype.searchFilter = function () {
    this.searchFilterFn({ev: 0});
  };

  FilterTableActionsCtrl.prototype.clearFilter = function () {
    this.clearFilterFn({ev: 0});
  };

  FilterTableActionsCtrl.prototype.closeFilter = function () {
    this.closeFilterFn({ev: 0});
  };

  angular
  .module('mandaeApp')
  .controller('FilterTableActionsCtrl', FilterTableActionsCtrl);

}());